/**
 * Appends the selected variant title to the product title on PDP.
 * Reads the selected value from the change event target.
 */
(function () {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (payload) {
    var el = document.querySelector('[data-variant-title]');
    if (!el) return;
    var value = payload.data.target.dataset.variantTitle;
    if (value && value !== 'Default Title') {
      el.textContent = ' \u2014 ' + value;
    } else {
      el.style.display = 'none';
    }
  });
})();
